import { Input, Select } from "@frui.ts/bootstrap";
import DatePickerBox from "controls/datePickerBox";
import FormGroup from "controls/formGroup";
import FormLabel from "controls/formLabel";
import FuelType from "entities/fuelType";
import { observer } from "mobx-react-lite";
import React from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { emptyValue } from "utils/emptyValue";
import { onNumberInputKeyPress } from "utils/numberInput";
import type ChargeTypeDetailViewModel from "viewModels/timeCharges/chargeTypes/chargeTypeDetailViewModel";

export interface ChargeTypeFormProps {
  vm: ChargeTypeDetailViewModel;
  children?: React.ReactNode;
}

const ChargeTypeForm = observer((props: ChargeTypeFormProps) => {
  const { vm, children } = props;
  const fuelOrder = [FuelType.Other, FuelType.NaturalGas, FuelType.BioMethane, FuelType.PhevWithLimitedCo2];

  return (
    <>
      <Form.Row>
        <FormGroup as={Col} md="6" target={vm.item} property="name">
          <FormLabel>{vm.translateAttribute("name")}</FormLabel>
          <Input disabled />
        </FormGroup>
        <FormGroup as={Col} md="6" target={vm.item} property="chargeCode">
          <FormLabel>{vm.translateAttribute("chargeCode")}</FormLabel>
          <Input disabled />
        </FormGroup>
      </Form.Row>
      <Form.Row>
        <FormGroup as={Col} md="6" target={vm.item} property="validFor">
          <FormLabel>{vm.translateAttribute("validFor")}</FormLabel>
          <Select disabled items={vm.validForOptions} mode="key" />
        </FormGroup>
        <FormGroup as={Col} md="6" target={vm.item} property="notifyDaysBefore">
          <FormLabel>{vm.translateAttribute("notifyDaysBefore")}</FormLabel>
          {vm.item?.notifyDaysBefore == null ? (
            // Short charge types (1denni, 24hodinova) have no notification period.
            <Form.Control disabled value={emptyValue} />
          ) : (
            <Input disabled type="number" step={1} onKeyDown={onNumberInputKeyPress} />
          )}
        </FormGroup>
      </Form.Row>
      <Form.Row>
        <FormGroup as={Col} md="6" target={vm.item} property="validSince">
          <FormLabel>{vm.translateAttribute("validSince")}</FormLabel>
          <DatePickerBox disabled />
        </FormGroup>
        <FormGroup as={Col} md="6" target={vm.item} property="validUntil">
          <FormLabel>{vm.translateAttribute("validUntil")}</FormLabel>
          <DatePickerBox disabled />
        </FormGroup>
      </Form.Row>
      <Form.Row>
        <div className="col-12">
          <h5>{vm.translateAttribute("prices")}</h5>
        </div>
        {(vm.item?.prices || [])
          .sort((a, b) => fuelOrder.indexOf(a.fuelType) - fuelOrder.indexOf(b.fuelType))
          .map(price => {
            const fuelType = vm.allFuelTypes.find(fuel => fuel.fuelType === price.fuelType);
            return (
              <FormGroup as={Col} key={price.fuelType} md={6} target={price} property="price">
                <FormLabel>{fuelType?.name ?? price.fuelType}</FormLabel>
                <Input disabled type="number" />
              </FormGroup>
            );
          })}
      </Form.Row>
      {children}
    </>
  );
});

export default ChargeTypeForm;
